import styled from "styled-components";
import { theme } from "../theme";

export const StyledField = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: ${({ mb }) => mb || 0};

	&:nth-of-type(1) {
		margin-top: 0;
	}

	span {
		font-family: ${theme.font.secondary};
		font-weight: 500;
		flex-wrap: wrap;
		display: flex;
		align-items: center;

		& > img {
			margin-right: .5rem;
		}
	}

	i {
		margin-right: 0.5rem;
		display: inline-flex;
		justify-content: center;
		align-items: center;
	}

	& .label {
		display: flex;
		flex-direction: column;
		row-gap: 0.5rem;
		font-size: 0.8rem;
		font-weight: 500;
		font-family: museo-sans,sans-serif;
		color: #4D5660;
		margin-bottom: 0.1rem;
		text-transform: uppercase;
}
	}

	textarea {
		width: auto;
		min-height: ${({ edit }) => (edit ? "15.5rem" : "25rem")};
		font-size: ${({ edit, small }) => (edit ? (small ? "inherit" : "25px") : "inherit")};
		font-weight: ${({ edit, small }) => (edit ? (small ? "inherit" : "900") : "inherit")};
		padding: ${({ edit, small }) => (edit ? (small ? "1rem" : "1.5rem") : "inherit")};
	}

	label {
		button {
			margin-left: 1rem;
		}
	}

	.wrapper {
		display: flex;
		align-items: flex-start;

		button {
			margin: 0 0 0 1.5rem;
			background: transparent;
			border: none;
			outline: none;
			cursor: pointer;
		}
	}
`;
